export interface PerformanceReport {
  readonly averageFrameMs: number
  readonly minimumFps: number
  readonly p95FrameMs: number
  readonly sampleCount: number
}

const SAMPLE_CAPACITY = 240

export class PerformanceMonitor {
  private readonly samples = new Float32Array(SAMPLE_CAPACITY)
  private cursor = 0
  private count = 0
  private elapsedSinceReport = 0
  private latestReport: PerformanceReport = { averageFrameMs: 16.67, minimumFps: 60, p95FrameMs: 16.67, sampleCount: 0 }

  public addFrame(frameMs: number): PerformanceReport | null {
    const safeFrameMs = Math.max(0.01, Math.min(250, frameMs))
    this.samples[this.cursor] = safeFrameMs
    this.cursor = (this.cursor + 1) % SAMPLE_CAPACITY
    this.count = Math.min(SAMPLE_CAPACITY, this.count + 1)
    this.elapsedSinceReport += safeFrameMs
    if (this.elapsedSinceReport < 1_000) return null
    this.elapsedSinceReport = 0
    this.latestReport = this.calculate()
    return this.latestReport
  }

  public get latest(): PerformanceReport {
    return this.latestReport
  }

  private calculate(): PerformanceReport {
    const ordered = Array.from(this.samples.slice(0, this.count)).sort((a, b) => a - b)
    const total = ordered.reduce((sum, sample) => sum + sample, 0)
    const p95Index = Math.max(0, Math.ceil(ordered.length * 0.95) - 1)
    const maximum = ordered[ordered.length - 1] ?? 16.67
    return {
      averageFrameMs: total / Math.max(1, ordered.length),
      minimumFps: 1_000 / maximum,
      p95FrameMs: ordered[p95Index] ?? 16.67,
      sampleCount: ordered.length,
    }
  }
}
